export default __webpack_public_path__ + "static/media/NATIONAL GAMES LOGO_01-11.f6663f78.png";